import {
  useV2ListResourcesForAccountQuery,
  V2ResourceResource,
} from "@generated";

const useListResources = () => {
  const { data, isLoading, error } = useV2ListResourcesForAccountQuery({
    filter: { active: true } as any,
    page: { number: 1, size: 1000 },
  });

  const resources: V2ResourceResource[] = (data?.data ?? []).filter(
    (r) => r.id
  );

  return { resources, resourcesLoading: isLoading, error };
};

export default useListResources;
